import { Component, OnInit } from '@angular/core';
import { Transaction } from '../../../app/models';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { PaymentMethodsService } from 'src/app/services/payment-methods.service';
import { GeneralTool } from '../split-payment/tools/general-tools';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {

  user: Transaction;
  itsValidToken = true;
  itsValidImg = true;

  constructor(private readonly tokenServiceService: TokenServiceService, private readonly paymentMethodsService: PaymentMethodsService) { }

  ngOnInit() {
    this.user = this.tokenServiceService.getAndDecodeToken();
    this.validOrder();

    if (!GeneralTool.itsValidImage(this.user.MERCHANT_LOGO ?? '')) {
      this.itsValidImg = false;
      return;
    }
  }

  /**
   * @description Function to validate user's order 
  */
  async validOrder() {
    try {
      await this.paymentMethodsService.Order();
    } catch (_) {
      this.itsValidToken = false;
    }
  }
}
